import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-toast/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Input"] */ "/app/node_modules/@umahealth/occipital/dist/client.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-loading-skeleton/dist/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-loading-skeleton/dist/skeleton.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/RiesgoCardiovascular/assets/heartbeat.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/RiesgoCardiovascular/styles/welcome.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["CloseButton"] */ "/app/src/storybook/components/sharedComponents/Header/Header_CloseButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/storybook/components/sharedComponents/Header/Header_LeftButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/storybook/components/sharedComponents/Header/Header_Profile.tsx");
